"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateBosCustomerMutation = exports.convertBosContactToBosCustomerMutation = exports.createBosCustomerMutation = exports.updateOrderCustomerMinimalMutation = exports.updateCustomerMutation = exports.createCustomerMutation = void 0;
const types_1 = require("../../types");
exports.createCustomerMutation = `
  mutation createBosCustomerForOrderId($id: ID!, $input: BosApiCustomerInput!, $isContact: Boolean) {
    createBosCustomerForOrderId(id: $id, input: $input, isContact: $isContact) {
      ...order
    }
  }
  ${types_1.orderFragments}
`;
exports.updateCustomerMutation = `
  mutation updateBosCustomerForOrderId($id: ID!, $input: BosApiCustomerInput!, $ignoreErrors: Boolean) {
    updateBosCustomerForOrderId(id: $id, input: $input, ignoreErrors: $ignoreErrors) {
      ...order
    }
  }
  ${types_1.orderFragments}
`;
exports.updateOrderCustomerMinimalMutation = `
  mutation updateOrderCustomerInfo($id: ID!, $input: BosApiCustomerInput!) {
    updateOrderCustomerInfo(id: $id, input: $input) {
      ...order
    }
  }  
  ${types_1.minimalOrderFragments}
`;
exports.createBosCustomerMutation = `
  mutation createBosCustomer($input: BosCustomerInput!) {
    createBosCustomer(input: $input) {
      ...bosCustomer
    }
  }
  ${types_1.bosCustomerFragment}
`;
exports.convertBosContactToBosCustomerMutation = `
  mutation convertBosContactToBosCustomer($customerId: String!) {
    convertBosContactToBosCustomer(customerId: $customerId) {
      ...bosCustomer
    }
  }
  ${types_1.bosCustomerFragment}
`;
exports.updateBosCustomerMutation = `
  mutation updateBosCustomer($input: BosCustomerInput!, $ignoreErrors: Boolean) {
    updateBosCustomer(input: $input, ignoreErrors: $ignoreErrors) {
      ...bosCustomer
    }
  }
  ${types_1.bosCustomerFragment}
`;
//# sourceMappingURL=customer.js.map